/// <reference path="../typings/index.d.ts" />

declare var chrome: any;
declare var swal: any;
namespace App.Modulos {
    export class Bot {
        public static inicializar() {
            var bot = new App.Bot();
            bot.inicializarEventos();
        }
    }
}
namespace App {
    export class Bot {
        private ajax: IAjax;
        public static players: any = null;
        private elFormConfig: JQuery = $('.form-step-config-bot');
        private elFormConfigCredenciais: JQuery = $('.form-step-config-credenciais-bot');
        private elFormConfigAddConta: JQuery = $('#formConfiguracoesBotAddConta');
        private elFormConfiguracoesGeralBot: JQuery = $("#formConfiguracoesGeralBot");
        private elInfoLigarSistema: JQuery = $("#infoLigarSistema");

        private elBtStartBot: JQuery = $("#btnStartBot");
        private elBtStopBot: JQuery = $("#btnStopBot");
        private elBtAddConta: JQuery = $("#btnAddConta");
        private elInfoDesconectado: JQuery = $(".btn-desconectado");

        private elBtStart: JQuery = $(".btn-start");
        private elBtSbc: JQuery = $(".btn-sbc");
        private elBtPause: JQuery = $(".btn-pause");
        private elBtStop: JQuery = $(".btn-stop");
        private elBtStatistica: JQuery = $(".btn-statistic");
        private elBtAutenticar: JQuery = $(".btn-autenticar");
        private elBtResolverCaptcha: JQuery = $(".btn-resolver-captcha");
        private elFiltroExigido: JQuery = $(".filtro-exigido");
        private elBtExcluirConta: JQuery = $(".btn-excluir-conta");
        private elBtConfigurar: JQuery = $(".btn-configurar");
        private elBtCodeMock: JQuery = $(".btn-code-mock");
        private elBtTestarBot: JQuery = $(".btn-testar-bot");
        private elDataTableLogs: any = $("#datatableLogs");

        private objSelect2: ISelect2 = null;
        private objDataTableLogs: any = null;
        private filtrosEa: FiltrosEa = null;

        private socketClientBot: any = null;
        private arrayContas: IConta[] = [];
        private comunicacao: Comunicacao = null;
        private contadorJustGage: ContadorJustGage = null;
        private elementoConsolidadoBuscas: any = {};
        private elementoConsolidadoCompras: any = {};
        private elementoConsolidadoCaptchas: any = {};
        private selectTextMilisegundosComplementoDefault: string = " milliseconds";
        private buttonStartBot: ILaddaButtonLoading = null;
        private buttonStopBot: ILaddaButtonLoading = null;

        public static cronometros: any = {};
        public agendamentos: any = {};

        private alertDesconectado: any = null;
        private alertPrecisaAddConta: any = null;
        private conectado: boolean = false;

        public inicializarEventos() {
            this.ajax = new App.Ajax();
            this.elBtStartBot.on('click', (e) => { this.aoClicarIniciarBot(e); });
            this.elBtStopBot.on('click', (e) => { this.aoClicarPararBot(e); });
            this.elBtAddConta.on('click', (e) => { this.aoAddConta(e); });
            this.elInfoDesconectado.on('click', (e) => { this.aoClicarInfoDesconectado(e); });

            this.elBtStart.on('click', (e) => { this.aoClicarIniciarConta(e); });
            this.elBtSbc.on('click', (e) => { this.aoClicarIniciarSbc(e); });
            this.elBtPause.on('click', (e) => { this.aoClicarPausarConta(e); });
            this.elBtStop.on('click', (e) => { this.aoClicarPararConta(e) });
            this.elBtStatistica.on('click', (e) => { this.aoClicarStatisticaConta(e); });
            this.elBtAutenticar.on('click', (e) => { this.aoClicarAutenticarConta(e); });
            this.elBtResolverCaptcha.on('click', (e) => { this.aoClicarResolverCaptchaConta(e); });
            this.elBtConfigurar.on('click', (e) => { this.aoClicarConfigurarConta(e); });
            this.elBtCodeMock.on('click', (e) => { this.aoEnviarCodeStatusMock(e); });
            this.elBtTestarBot.on('click', (e) => { this.aoTestarBot(e); });
            this.elBtExcluirConta.on("click", (e) => { this.aoExcluirRegistro(e) });
            this.elFiltroExigido.on("click", (e) => { this.aoClicarAgendamentoSemFiltro(e) });
            this.elFormConfig.on("submit", (e) => { this.aoSalvarAgendamentoConta(e) });
            this.elFormConfigCredenciais.on("submit", (e) => { this.aoSubmeterFormContaCredenciais(e) });
            this.elFormConfigAddConta.on("submit", (e) => { this.aoSubmeterFormAddConta(e) });
            this.elFormConfiguracoesGeralBot.on("submit", (e) => { this.aoSubmeterFormConfiguracaoGeralBot(e) });

            this.buttonStartBot = new LaddaButtonLoading();
            this.buttonStartBot.inicializarCampo("#btnStartBot");
            this.buttonStopBot = new LaddaButtonLoading();
            this.buttonStopBot.inicializarCampo("#btnStopBot");

            var modelView = new ModelView();
            modelView.inicializar($('#formFiltroPro'), false, () => {
                App.Util.exibirModalPaginaCarregando();
                window.location.href = $("#formFiltroPro").data('url-aba-filtro');
            });
            modelView._this = this;
            modelView.aoEditarRegistro = this.aoEditarRegistro;
            App.Util.exebirSweetConfirmacao = App.Bot.exibirSweetConfirmacaoHtml;

            this.contadorJustGage = new ContadorJustGage();

            var objSocketIo = new SocketIo();
            this.socketClientBot = objSocketIo.inicializarCampo("http://localhost:5000", App.Util.usuario.id, App.Util.usuario.api_token);
            this.comunicacao = new Comunicacao(this.socketClientBot);
            this.inicializarComunicacao();

            this.objSelect2 = new Select2();
            this.getPlayers(() => {
                this.continuarInicializacao();
            });
        }

        private continuarInicializacao() {
            $('.modal-step-config').each(function (index, value) {
                var cloneData = new CloneData();
                cloneData.inicializarCampo($('a#' + $(value).find('.add-more-sch').attr('id')), 0, 6, $(value).find('.main-container-sch').attr('id'), $(value).find('.container-item-sch').data('classContainerItem'), $(value).find('.remove-item-sch').data('classRemove'), Util.getOptionsSelectTag());
            });
            this.objSelect2.inicializarCampo($('.select2'));
            this.objSelect2.inicializarCampo($('.select-tag'), Util.getOptionsSelectTag());
            this.filtrosEa = new FiltrosEa();
            this.filtrosEa.inicializarEventos();

            setTimeout(() => {
                this.obterConfiguracoesContasSalvas();
                this.obterLogsDoDia();
                App.Util.ocultarModalPaginaCarregando();
                this.atualizarViewInfoAgendamentos(this.agendamentos);
                if (!this.conectado) {
                    this.exibirAlertaMotorNaoConectado();
                    return;
                }
            }, 2000);
        }
        private getPlayers(metodoCallback: any) {
            $.getJSON("/players.json", { _: new Date().getTime() }, (data) => {
                Bot.players = data.Players;
                metodoCallback();
            });
        }

        public aoEditarRegistro(e: JQueryEventObject, _this: this) {
            var modal = $("#modalCadastrarFiltroPro");
            modal.modal('show');
            var id: number = $(e.currentTarget).data("id");
            var nome: string = $(e.currentTarget).data("nome");
            var dados: IDataFiltroPro = $(e.currentTarget).data("dados");
            _this.filtrosEa.setCampoInputName("id", id);
            _this.filtrosEa.setCampoInputName("nome", nome);
            _this.filtrosEa.setCampoJogador(dados.data.maskedDefId, Bot.players);
            _this.filtrosEa.setCampoSelect2("quality", dados.data.quality);
            _this.filtrosEa.setCampoSelect2("rarity", dados.data.rarity);
            _this.filtrosEa.setCampoSelect2("position", dados.data.position);
            _this.filtrosEa.setCampoSelect2("chemical", dados.data.chemical);
            _this.filtrosEa.setCampoSelect2("nation", dados.data.nation);
            _this.filtrosEa.setCampoSelect2("league", dados.data.league);
            _this.filtrosEa.setCampoSelect2("club", dados.data.club);
            _this.filtrosEa.setCampoInputName("maxBuyNow", dados.data.minBuyNow);
            _this.filtrosEa.setCampoInputName("maxBuyNow", dados.data.maxBuyNow);
            _this.filtrosEa.setCampoInputRadio("precoCompra", dados.data.lucro ? "2" : "1");
            _this.filtrosEa.setCampoInputCheckbox("ativar_venda_automatica", !App.Util.empty(dados.venda));
            _this.filtrosEa.setCampoInputCheckbox("precoInteligente", !App.Util.empty(dados.venda) && dados.venda.precoInteligente);
            _this.filtrosEa.setCampoInputCheckbox("precoFutbin", !App.Util.empty(dados.venda) && dados.venda.precoFutbin);
            _this.filtrosEa.setCampoInputName("lucro", dados.data.lucro);
            _this.filtrosEa.setCampoInputName("porcentagemMaisBarato", dados.venda.porcentagemMaisBarato);
            _this.filtrosEa.setCampoInputName("valor_lance_minimo", dados.venda.valorLanceMinimo);
            _this.filtrosEa.setCampoInputName("valor_venda", dados.venda.valorVenda);
        }

        private inicializarComunicacao() {
            this.comunicacao.socket.on('disconnect', () => {
                this.conectado = false;
                this.processarConexaoDisconexao();
                this.exibirViewConexao();
                this.agendamentos = {};
                this.atualizarViewInfoAgendamentos(this.agendamentos);
            });
            this.comunicacao.socket.on(Comunicacao.CANAL_RECEIVE, (acao: number, request: any, callback: any = null) => {
                switch (acao) {
                    case Comunicacao.RECEBER_CONFIRMACAO_CONECTADO:
                        this.conectado = true;
                        console.log("RECEBER_CONFIRMACAO_CONECTADO:: " + acao, request.agendamentos);
                        this.agendamentos = request.agendamentos;
                        toastr.success("Sistema está conectado", "Conectado!");
                        this.exibeOcultaInfoLigarSistema();
                        this.exibirViewConexao();
                        this.processarConexaoDisconexao();
                        break;
                    case Comunicacao.RECEBER_PEDIR_CODIGO_VALIDACAO:
                        this.solicitarCodigoValidacao(request);
                        break;
                    case Comunicacao.RECEBER_ATUALIZAR_CONTA:
                        this.atualizarConta(request);
                        break;
                    case Comunicacao.RECEBER_ATUALIZACAO_STATUS:
                        this.atualizarStatusConta(request);
                        break;
                    case Comunicacao.RECEBER_CONSOLIDADOS_DIA:
                        this.receberConsolidadosContas(request);
                        break;
                    case Comunicacao.RECEBER_LOG:
                        this.receberLogs(request);
                        break;
                    case Comunicacao.RECEBER_EVENTO:
                        this.receberEvento(request);
                        break;
                    case Comunicacao.RECEBER_STATUS_EXECUCAO:
                        this.receberStatusExecucao(request);
                        break;
                    case Comunicacao.RECEBER_ALERTA_AUTENTICACAO_FALHOU:
                        this.receberFalhaNaAutenticacao(request);
                        break;
                    case Comunicacao.RECEBER_ALERTA_AUTENTICACAO_CONCLUIDA:
                        this.receberAutenticacaoConcluida(request);
                        break;
                }
            });
        }

        private receberLogs(dataLog: IDataLog | IDataLog[]) {
            this.carregarTabelaLogs(dataLog);
        }

        private carregarTabelaLogs(dataLog: IDataLog[] | IDataLog) {
            if (this.objDataTableLogs instanceof $.fn.dataTable.Api) {
                if ($.isArray(dataLog)) {
                    this.objDataTableLogs.clear().draw();
                    this.objDataTableLogs.rows.add(dataLog);
                } else {
                    this.objDataTableLogs.row.add(dataLog);
                }
                this.objDataTableLogs.columns.adjust().draw();
            } else {
                this.objDataTableLogs = this.elDataTableLogs.DataTable({
                    data: dataLog,
                    order: [[3, "desc"]],
                    lengthChange: false,
                    dom: "Bfrtip",
                    buttons: {
                        buttons: [
                            { extend: 'copy', className: 'btn-link' },
                            { extend: 'print', className: 'btn-link' }
                        ]
                    },
                    language: {
                        paginate: {
                            previous: "<i class='fas fa-angle-left'>",
                            next: "<i class='fas fa-angle-right'>"
                        }
                    },
                    columnDefs: [
                        {
                            targets: 0,
                            className: "name",
                            render: (data: any, tipo: any, obj: IDataLog, meta: any) => {
                                data = 'Conta Excluída';
                                var conta: IConta = App.Util.getItemArrayById(this.arrayContas, obj.idConta);
                                if (conta && conta.hasOwnProperty('dadosEa') && conta.dadosEa) {
                                    data = '<div class="media align-items-center">\n\
                                            <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;">\n\
                                            <img alt="Clube Name" src="'+ conta.dadosEa.img + '">\n\
                                            </a><div class="media-body">\n\
                                            <span class="name mb-0 text-sm">'+ conta.dadosEa.clubeName + '</span>\n\
                                            </div>\n\
                                            </div>'
                                } else if (conta) {
                                    data = '<div class="media align-items-center">\n\
                                            <a href="#" class="avatar rounded-circle mr-3" style="width: 20px;height: 20px;">\n\
                                            <img alt="Clube Name" src="/img/escudo-default.png">\n\
                                            </a><div class="media-body">\n\
                                            <span class="name mb-0 text-sm">Account ' + conta.id + '</span>\n\
                                            </div>\n\
                                            </div>';
                                }
                                return data;
                            }
                        },
                        {
                            targets: 1,
                            className: "tipo",
                            render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                                var dadosLog = Util.getObjStatusViewLog(obj);
                                data = '<span class="badge badge-' + dadosLog.class + '">' + dadosLog.texto + '</span>'
                                return data;
                            }
                        },
                        {
                            targets: 2,
                            className: "text-muted info",
                            render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                                return Util.getObjInfoViewLog(obj);
                            }
                        },
                        {
                            targets: 3,
                            className: "date",
                            render: function (data: any, tipo: any, obj: IDataLog, meta: any) {
                                data = '<div class="text-right">\n\
                                        <small class="text-muted">'+ obj.createdAt + '&nbsp;&nbsp;<i class="fas fa-clock mr-1"></i></small>\n\
                                        </div>';
                                return data;
                            }
                        }
                    ],
                });
            }
        }

        private obterConfiguracoesContasSalvas() {
            console.log({ ids: $('#cardContas').data('ids') });
            this.comunicacao.enviar(Comunicacao.REQUEST_OBTER_CONFIG_CONTAS, { ids: $('#cardContas').data('ids') }, (response: IRespostaMensagem) => {
                if (response.status) {
                    console.log("🚀 ~ file: Bot.ts ~ line 311 ~ Bot ~ this.comunicacao.enviar ~ response.status", response)
                    this.arrayContas = response.result.contas.filter((result: IConta) => {
                        return _.contains($('#cardContas').data('ids'), result.id);
                    });
                    console.log("AZZZ", response.result, this.arrayContas);
                    this.atualizarConfiguracoes(response.result.configuracoes);
                    this.atualizarListagemConta(this.arrayContas);
                }
            });
        }
        private obterLogsDoDia() {
            this.comunicacao.enviar(Comunicacao.REQUEST_OBTER_LOGS, {}, (response: IRespostaMensagem) => {
                if (response.status) {
                    this.carregarTabelaLogs(response.result);
                }
            });
        }
        private receberConsolidadosContas(consolidados: any | IContaConsolidado[]) {
            if ($.isArray(consolidados)) {
                $.each(consolidados, (index: number, consolidado: IContaConsolidado) => {
                    this.atualizarConsolidados(consolidado);
                });
            } else {
                this.atualizarConsolidados(consolidados);
            }
        }

        private atualizarConsolidados(consolidado: IContaConsolidado) {
            console.log(consolidado);
            try {
                // if (this.elementoConsolidadoBuscas.hasOwnProperty(consolidado.id_conta)) {
                //     this.elementoConsolidadoBuscas[consolidado.id_conta].refresh(consolidado.buscas);
                // } else {
                //     this.elementoConsolidadoBuscas[consolidado.id_conta] = this.contadorJustGage.inicializarCampo("contadorBuscas" + consolidado.id_conta, "Searches", consolidado.buscas, 0, 5000);
                // }

                // if (this.elementoConsolidadoCompras.hasOwnProperty(consolidado.id_conta)) {
                //     this.elementoConsolidadoCompras[consolidado.id_conta].refresh(consolidado.compras);
                // } else {
                //     this.elementoConsolidadoCompras[consolidado.id_conta] = this.contadorJustGage.inicializarCampo("contadorCompras" + consolidado.id_conta, "Sales", consolidado.compras, 0, 500);
                // }

                // if (this.elementoConsolidadoCaptchas.hasOwnProperty(consolidado.id_conta)) {
                //     this.elementoConsolidadoCaptchas[consolidado.id_conta].refresh(consolidado.captchas);
                // } else {
                //     this.elementoConsolidadoCaptchas[consolidado.id_conta] = this.contadorJustGage.inicializarCampo("contadorCaptchas" + consolidado.id_conta, "Captchas", consolidado.captchas, 0, 10);
                // }
            } catch (e) {
                console.log("ERROR", e);
            }

            let elementoLinhaConta = $('#conta' + consolidado.id);
            if (consolidado.lucro >= 0) {
                elementoLinhaConta.find('.lucro-down').hide();
                elementoLinhaConta.find('.lucro-up').show();
                elementoLinhaConta.find('.lucro-up .lucro').html(consolidado.lucro.toString());
            } else {
                elementoLinhaConta.find('.lucro-up').hide();
                elementoLinhaConta.find('.lucro-down').show();
                elementoLinhaConta.find('.lucro-down .lucro').html(consolidado.lucro.toString());
            }
        }

        private atualizarConta(conta: IConta) {
            var contaAtual: IConta = App.Util.getItemArrayById(this.arrayContas, conta.id);
            if (conta.dadosEa) {
                contaAtual.dadosEa = conta.dadosEa;
            }
            Util.updateOrCreateItemArrayByEmail(this.arrayContas, conta.email, contaAtual);
            this.atualizarViewConta(conta);
        }

        private atualizarStatusConta(conta: IConta) {
            this.atualizarViewStatusConta(conta);
        }

        private atualizarViewConta(conta: IConta) {
            let elementoLinhaConta = $('#conta' + conta.id);

            if (conta.dadosEa) {
                elementoLinhaConta.find('.sem-configuracao').hide();
                elementoLinhaConta.find('.com-configuracao').show();
                if (!elementoLinhaConta.data('idContaEa')) {
                    var dadosBaseContaEa = {
                        update_id: conta.id,
                        id: conta.dadosEa.idConta,
                        usuario_id: conta.dadosEa.idUsuario,
                        clube: conta.dadosEa.clubeName,
                        ptf: conta.dadosEa.plataforma,
                        coins: conta.dadosEa.coins
                    }
                    console.log("dadosBaseContaEa", App.Util.config.urlSalvarContaEa, dadosBaseContaEa);
                    this.ajax.postAcaoSemCabecalhoGlobal(App.Util.config.urlSalvarContaEa, dadosBaseContaEa);
                }

                elementoLinhaConta.find('.simbolo-clube').attr('src', conta.dadosEa.img);
                elementoLinhaConta.find('.conta-clube-nome').html(conta.dadosEa.clubeName);
                elementoLinhaConta.find('.badge-plataforma').html(conta.dadosEa.plataforma);
                elementoLinhaConta.find('.info-id-conta-ea').html("#" + conta.dadosEa.idConta.toString());
                elementoLinhaConta.find('.coins-conta').show();
                elementoLinhaConta.find('.coins').html(conta.dadosEa.coins.toLocaleString('pt-BR'));
                // if (_.contains(Util.ARRAY_STATUS_CONTA_ATIVA, conta.status)) {
                //     this.exibirContaAutenticada(elementoLinhaConta, conta);
                // } else {
                //     this.exibirContaNaoAutenticada(elementoLinhaConta, conta);
                // }
            } else {
                elementoLinhaConta.find('.conta-clube-nome').html(conta.email);
            }
        }

        private atualizarViewInfoAgendamentos(arrayAgendamentos: any[] = []) {
            var agendamentoEncontrado = false;
            $.each(arrayAgendamentos, (idConta: any, dados: IProgramacaoAgendamentos) => {
                console.log(idConta, dados);
                let elementoLinhaConta = $('#conta' + idConta);
                elementoLinhaConta.find('.btn-info-agenda').hide();
                elementoLinhaConta.find('.btn-info-agenda').attr('data-content', '');
                if (dados.programacao.length) {
                    agendamentoEncontrado = true;
                    var strDataPopovers = '';
                    $.each(dados.programacao, (index: any, descAgenda: string) => {
                        strDataPopovers += `<p class="mb-0"><span><i class="ni ni-time-alarm text-success font-size-10"></i></span>&nbsp;<small>${descAgenda}</small></p>`
                    });
                    elementoLinhaConta.find('.btn-info-agenda').show();
                    elementoLinhaConta.find('.btn-info-agenda').attr('data-content', `${strDataPopovers}`);
                }
            });

            if (agendamentoEncontrado) {
                this.buttonStartBot.exibirLoading();
            } else {
                this.buttonStartBot.ocultarLoading();
                $('.btn-info-agenda').hide();
                $('.btn-info-agenda').attr('data-content', '');
            }
        }

        private atualizarViewFuncionamentoAtual(conta: IConta, dadosFuncionamento: IFuncionamentoAtual) {
            var objDescFuncionamento = Util.getDescFuncionamentoAtual(dadosFuncionamento);
            let elementoLinhaConta = $('#conta' + conta.id);
            elementoLinhaConta.find('.info-intervalo').html(objDescFuncionamento.intervalo);
            elementoLinhaConta.find('.info-descanso').html(objDescFuncionamento.descanso);
            elementoLinhaConta.find('.info-velocidade').html(objDescFuncionamento.velocidade);
            elementoLinhaConta.find('.info-filtro').html(dadosFuncionamento.filtro.toString());
            Util.iniciarCronometro(App.Bot.cronometros[conta.id], elementoLinhaConta.find('.cronometro .info-tempo'), dadosFuncionamento.tempo / 1000);
        }

        private reinicializarViewFuncionamentoAtual(conta: IConta) {
            let elementoLinhaConta = $('#conta' + conta.id);
            elementoLinhaConta.find('.info-intervalo').html("-");
            elementoLinhaConta.find('.info-descanso').html("-");
            elementoLinhaConta.find('.info-velocidade').html("-");
            elementoLinhaConta.find('.info-filtro').html("-");
            Util.pararCronometro(App.Bot.cronometros[conta.id], elementoLinhaConta.find('.cronometro .info-tempo'));
        }

        private atualizarViewStatusConta(conta: IConta) {
            let elementoLinhaConta = $('#conta' + conta.id);
            var objStatus: IStatusContaView = Util.getObjStatusView(conta.status);
            var infoStatus = elementoLinhaConta.find('.badge-status');
            infoStatus.attr('class', 'badge badge-status badge-' + objStatus.class);
            infoStatus.html(objStatus.texto);
            // if (_.contains(Util.ARRAY_STATUS_CONTA_EM_EXECUCAO, conta.status)) {
            //     this.exibirContaAutenticada(elementoLinhaConta, conta);
            //     elementoLinhaConta.find(".loading-conta").show();
            // } else {
            //     elementoLinhaConta.find(".loading-conta").hide();
            //     if (conta.status == Util.STATUS_CONTA_COM_CAPTCHA) {
            //         elementoLinhaConta.find('.btn-resolver-captcha').show();
            //     } else {
            //         elementoLinhaConta.find('.btn-resolver-captcha').hide();
            //     }
            // }
        }

        private atualizarListagemConta(arrayContas: IConta[]): void {
            $.each(arrayContas, (index: any, conta: IConta) => {
                App.Bot.cronometros[conta.id] = new Timer();
                this.preencherCamposFormEview(conta);
                this.atualizarViewConta(conta);
                this.atualizarViewStatusConta(conta);
            });
        }

        private atualizarConfiguracoes(configuracoes: IConfiguracoesGeral): void {
            $("#modoPotente").prop("checked", (configuracoes && configuracoes.modoPotente)).trigger('change');
        }

        private preencherCamposFormEview(conta: IConta): void {
            var formContaCredenciais = $("#formCredenciaisBot" + conta.id);
            formContaCredenciais.find('input[name=email]').val(conta.email);
            formContaCredenciais.find('input[name=senha]').val(conta.senha);

            var formConta = $("#formConfiguracoesBot" + conta.id);
            var modalContaConfig = $("#modalConfigAgendamento" + conta.id);

            $.each(conta.configuracao.agendamentos, (index: any, agendamento: IAgendamentoConfiguracao) => {
                if (index > 0) {
                    modalContaConfig.find('#add-more' + conta.id).click();
                }

                var funcaoData: IFuncaoSniperOptions = agendamento.tarefa.data;
                var elementoContainer: JQuery = formConta.find('#containerItem' + index);
                elementoContainer.find("select[name='dia[]']").val(agendamento.dia);
                elementoContainer.find("input[name='hora[]']").val(agendamento.hora);

                var selectVelocidade: JQuery = elementoContainer.find("select[name='velocidade[]']");
                var selectDescanso: JQuery = elementoContainer.find("select[name='descanso[]']");
                var selectIntervalo: JQuery = elementoContainer.find("select[name='intervalo[]']");
                var selectTempo: JQuery = elementoContainer.find("select[name='tempo[]']");

                this.objSelect2.setSelectTag(selectVelocidade, { id: funcaoData.velocidade.toString(), text: (funcaoData.velocidade.toString() + this.selectTextMilisegundosComplementoDefault) })
                this.objSelect2.setSelectTag(selectDescanso, { id: funcaoData.descanso.toString(), text: (funcaoData.descanso.toString() + this.selectTextMilisegundosComplementoDefault) })
                this.objSelect2.setSelectTag(selectIntervalo, { id: funcaoData.intervalo.toString(), text: (funcaoData.intervalo.toString() + this.selectTextMilisegundosComplementoDefault) })
                this.objSelect2.setSelectTag(selectTempo, { id: funcaoData.tempo.toString(), text: (funcaoData.tempo.toString() + this.selectTextMilisegundosComplementoDefault) })

                var filtrosSelect: string[] = [];
                elementoContainer.find("input[name='porcentagem_eficacia[]']").val(funcaoData.porcentagem_eficacia);
                elementoContainer.find("input[name='tempo_minimo_eficacia[]']").val(funcaoData.tempo_minimo_eficacia);
                elementoContainer.find("input[name='limite_compra[]']").val(funcaoData.limite_compra);


                $.each(funcaoData.filtros, function (index2: any, filtro: IFiltroOptions) {
                    filtrosSelect.push(filtro.id);
                });

                formConta.find('select.select2').eq(index).val(filtrosSelect).trigger('change').trigger('select2:select');
                this.preencherInfoAgenda(elementoContainer, agendamento)
            });
        }

        private preencherInfoAgenda(elementoContainerOuConta: any = null, agendamento: IAgendamentoConfiguracao = null) {
            if (!agendamento) {
                $.each(elementoContainerOuConta.configuracao.agendamentos, (index: any, agendamento: IAgendamentoConfiguracao) => {
                    var formConta = $("#formConfiguracoesBot" + elementoContainerOuConta.id);
                    var elementoContainer: JQuery = formConta.find('#containerItem' + index);
                    if (agendamento) {
                        this.preencherInfoAgenda(elementoContainer, agendamento)
                    }
                });
                return;
            }

            var funcaoData: IFuncaoSniperOptions = agendamento.tarefa.data;
            console.log(elementoContainerOuConta, agendamento);
            elementoContainerOuConta.find('.info-quando').html(App.Util.ARRAY_DIAS_AGENDAMENTO[parseInt(agendamento.dia)]);
            elementoContainerOuConta.find('.info-hora').html(agendamento.hora);
            var strInfoFiltros = "";
            $.each(funcaoData.filtros, function (index: any, filtro: IFiltroOptions) {
                strInfoFiltros += `&nbsp;<span class="badge badge-pill badge-primary agenda-salva">${filtro.nome}</span>`
            });
            elementoContainerOuConta.find('.info-filtros').html(strInfoFiltros);
            this.exibeOcultaInfoLigarSistema();
        }

        private obterObjetoConta(form: JQuery, dadosResponse: any = null): IConta {
            var dadosEnviados: any = form.serializeObject();
            var arrFiltros = App.Util.filterPropObjByContainsString(dadosEnviados, "filtro");
            console.log("dadosContaBase", dadosEnviados, arrFiltros);

            var conta: IConta = {};
            conta.id = dadosResponse ? parseInt(dadosResponse.conta.id) : parseInt(dadosEnviados.id);
            if (dadosEnviados.hasOwnProperty('email')) {
                conta.email = dadosEnviados.email;
            }

            if (dadosEnviados.hasOwnProperty('senha')) {
                conta.senha = dadosEnviados.senha;
            }

            conta.configuracao = {};
            conta.configuracao.desativarCompartilhamento = true;
            conta.configuracao.delayRand = { ini: 1000, end: 2000 };
            conta.configuracao.agendamentos = [];

            if (_.isEmpty(dadosEnviados.id)) {
                conta.dadosEa = null;
                conta.status = Util.STATUS_CONTA_NAO_AUTENTICADA;
                return conta;
            }

            var arrayElementosAdd = form.find('.container-item-sch');
            $.each(arrayElementosAdd, (index: any, containerItem: any) => {

                // conta.configuracao.agendamentos.push({
                //     dia: dadosEnviados.dia[index],
                //     hora: dadosEnviados.hora[index],
                //     funcao: {
                //         id: Util.FUNCAO_SNIPER,
                //         data: {
                //             velocidade: dadosEnviados.velocidade[index],
                //             intervalo: dadosEnviados.intervalo[index],
                //             descanso: dadosEnviados.descanso[index],
                //             tempo: dadosEnviados.tempo[index],
                //             filtros: {},
                //         }
                //     },
                //     rotinas: null
                // });

                var funcaoData: IFuncaoSniperOptions = conta.configuracao.agendamentos[index].tarefa.data;
                console.log("🚀 ~ file: Bot.ts ~ line 602 ~ Bot ~ $.each ~ funcaoData", funcaoData, dadosEnviados)
                funcaoData.porcentagem_eficacia = dadosEnviados.hasOwnProperty('porcentagem_eficacia') ? dadosEnviados.porcentagem_eficacia[index] : 10;
                funcaoData.tempo_minimo_eficacia = dadosEnviados.hasOwnProperty('tempo_minimo_eficacia') ? dadosEnviados.tempo_minimo_eficacia[index] : 10;
                funcaoData.limite_compra = dadosEnviados.limite_compra[index];
                funcaoData.filtros = [];

                $.each(arrFiltros[index], (index2: any, filtroId: any) => {
                    var elementoSelect = form.find('.container-item-sch').eq(index).find('select.select2');
                    var elmento = elementoSelect.find('option[value=' + filtroId + ']');
                    var nome = elmento.data('nome');
                    var filtroData: IFiltroOptions = JSON.parse(elmento.attr('data-filtro'));

                    var novoFiltro: IFiltroOptions = {};
                    novoFiltro.id = filtroId;
                    novoFiltro.nome = nome;
                    novoFiltro.data = filtroData.data;
                    novoFiltro.venda = filtroData.venda;
                    funcaoData.filtros.push(novoFiltro);
                });
            });


            return conta;
        }

        public solicitarCodigoValidacao(request: any) {
            Util.ocultarModalPaginaCarregando();
            toastr.info("pediu código.", "Solicitação de código!");
            swal.fire({
                title: 'Informa o código enviado pela EA',
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: `Enviar`,
                denyButtonText: `Solicitar outro`,
                denyButtonColor: "#5e72e4",
                confirmButtonColor: "#2dce89",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then((result: any) => {
                if (result.isConfirmed) {
                    this.comunicacao.eniviarCodigoConfirmacao(request.email, result.value);
                    Util.exibirModalPaginaCarregando();
                } else if (result.isDenied) {
                    // Solicitar novo código
                    this.comunicacao.eniviarCodigoConfirmacao(request.email, null);
                    this.solicitarCodigoValidacao(request);
                    Util.exibirModalPaginaCarregando();
                } else {
                    // Cancelou processo informação de codigo
                    this.comunicacao.eniviarCodigoConfirmacao(request.email, 0);
                }
            })
        }

        private aoSalvarAgendamentoConta(e: JQueryEventObject) {
            e.preventDefault();
            var invalido = false;

            $(e.target).find(".select-filtro").each((index, value) => {
                if ($(value).val().length <= 0) {
                    invalido = true;
                    $('.collapse').collapse('hide')
                    setTimeout(() => {
                        $(value).parents('.collapse').collapse('show');
                        $(value).parents('.espaco-filtro').find('.error-filtro').show()
                        setTimeout(() => {
                            document.getElementById($(value).attr('id')).scrollIntoView();
                        }, 1000)
                    }, 1000)
                }
            });
            if (invalido) {
                toastr.warning("O agendamento precisa ter pelo menos 1 filtro", "Informe o Filtro!");
                return;
            }
            console.log("invalido", invalido);

            var objConta: IConta = this.obterObjetoConta($(e.target));
            console.log("objConta", objConta);
            this.comunicacao.enviar(Comunicacao.REQUEST_SALVAR_CONFIGURACOES, objConta, (response: IRespostaMensagem) => {
                if (response.status) {
                    // parentModal.modal('hide');
                    $(e.target).find('.error-filtro').hide()
                    $(e.target).find('.collapse').collapse('hide')
                    this.preencherInfoAgenda(objConta)
                    toastr.success("suas configurações foram atualizadas com sucesso.", "Configurações Atualizadas!");
                    Util.updateOrCreateItemArrayByEmail(this.arrayContas, response.result.email, response.result);
                    this.exibeOcultaInfoLigarSistema();
                }
            });
        }

        private aoSubmeterFormContaCredenciais(e: JQueryEventObject) {
            e.preventDefault();
            var parentModal = $(e.target).parents('.modal')
            if (!this.conectado) {
                parentModal.modal('hide');
                this.exibirAlertaMotorNaoConectado();
                return;
            }
            var objConta: IConta = this.obterObjetoConta($(e.target));
            console.log("objConta CRED", objConta);
            this.comunicacao.enviar(Comunicacao.REQUEST_SALVAR_CONFIGURACOES, objConta, (response: IRespostaMensagem) => {
                if (response.status) {
                    parentModal.modal('hide');
                    toastr.success("suas configurações foram atualizadas com sucesso.", "Configurações Atualizadas!");
                    Util.updateOrCreateItemArrayByEmail(this.arrayContas, response.result.email, response.result);
                }
            });
        }

        private aoSubmeterFormConfiguracaoGeralBot(e: JQueryEventObject) {
            e.preventDefault();
            var parentModal = $(e.target).parents('.modal')
            var configuracoes: IConfiguracoesGeral = { modoPotente: $(e.target).find('#modoPotente').is(':checked') };
            this.comunicacao.enviar(Comunicacao.REQUEST_SALVAR_CONFIGURACAO_GERAL, configuracoes, (response: IRespostaMensagem) => {
                console.log("🚀 ~ file: Bot.ts ~ line 676 ~ Bot ~ this.comunicacao.enviar ~ response", response)
                if (response.status) {
                    parentModal.modal('hide');
                    toastr.success("suas configurações foram atualizadas com sucesso.", "Configurações Atualizadas!");
                }
            });
        }

        private aoSubmeterFormAddConta(e: JQueryEventObject) {
            e.preventDefault();
            var parentModal = $(e.target).parents('.modal')
            parentModal.modal('hide');
            var dadosEnviados: any = $(e.target).serializeObject();
            Util.exibirModalPaginaCarregando();
            this.ajax.postAcaoSemCabecalhoGlobal(App.Util.config.urlSalvarContaEa, { email: dadosEnviados.email }, (dados: any) => {
                console.log("postAcaoSemCabecalhoGlobal", dados);
                var objConta: IConta = this.obterObjetoConta($(e.target), dados.dadosRetornados);
                this.comunicacao.enviar(Comunicacao.REQUEST_SALVAR_CONFIGURACOES, objConta, (response: IRespostaMensagem) => {
                    if (response.status) {
                        parentModal.modal('hide');
                        toastr.success("suas configurações foram atualizadas com sucesso.", "Configurações Atualizadas!");
                        window.location.reload();
                    }
                });
            });
        }

        private getArraContasOpenBrowser() {
            var arr: number[] = [];
            $("#cardContas input:checkbox[name=open_browser]:checked").each(function () {
                arr.push($(this).data('id'));
            });
            return arr;
        }

        private getArrayIdsContasModoPotente() {
            var arr: number[] = [];
            $("#cardContas input:checkbox[name=modo_potente]:checked").each(function () {
                arr.push($(this).data('id'));
            });
            return arr;
        }
        /**
         * Metodos BOT
         */
        private aoClicarIniciarBot(e: JQueryEventObject) {
            if (!this.conectado) {
                this.exibirAlertaMotorNaoConectado();
                return;
            }
            this.buttonStartBot.exibirLoading();
            this.comunicacao.enviar(Comunicacao.REQUEST_INICIAR_BOT, { idsContasOpenBrowsers: this.getArraContasOpenBrowser(), idsContasModoPotente: this.getArrayIdsContasModoPotente() }, (response: IRespostaMensagem) => {
                if (!response.status) {
                    console.log("NAO INICIOU", response.result);
                    this.alterarEstadoParaBotParado();
                    if (response.result.hasOwnProperty("contas") && !response.result.contas) {
                        this.exibirAlertaPrecisaAddConta();
                    }
                    if (response.result.hasOwnProperty("agendamento") && !response.result.agendamento) {
                        this.exibirAlertaNaoExisteAgenda();
                    }
                    return;
                }
                console.log("INICIOU", response);
                this.atualizarViewInfoAgendamentos(response.result);
                toastr.success("Sistema em Execução.", "Iniciado!");
                this.elInfoLigarSistema.hide()
            })
        }

        private aoClicarPararBot(e: JQueryEventObject) {
            if (!this.conectado) {
                this.exibirAlertaMotorNaoConectado();
                return;
            }
            this.buttonStopBot.exibirLoading();
            this.comunicacao.enviar(Comunicacao.REQUEST_PARAR_BOT, {}, (response: IRespostaMensagem) => {
                if (response.status) {
                    this.alterarEstadoParaBotParado()
                }
            })

        }

        private temAgendaSalva() {
            return Boolean($('.agenda-salva').length)
        }

        private exibeOcultaInfoLigarSistema() {
            console.log("RRRRRRRR", this.temAgendaSalva());
            if (this.temAgendaSalva()) {
                this.elInfoLigarSistema.show()
            } else {
                this.elInfoLigarSistema.hide()
            }
        }

        private pararTodosCronometros() {
            $.each(Object.keys(App.Bot.cronometros), (index: number, idConta: any) => {
                Util.pararCronometro(App.Bot.cronometros[idConta]);
            });
        }
        private alterarEstadoParaBotParado() {
            console.log("PAROU BOT");
            this.buttonStartBot.ocultarLoading();
            this.buttonStopBot.ocultarLoading();
            this.atualizarViewInfoAgendamentos();
            toastr.success("Sistema parado.", "Parou!");
            this.exibeOcultaInfoLigarSistema();
            this.pararTodosCronometros();
        }

        private aoEnviarCodeStatusMock(e: JQueryEventObject) {
            this.comunicacao.enviar(Comunicacao.REQUEST_CODE_STATUS_RESPONSE_MOCK, { code: 458 });

        }

        private aoTestarBot(e: JQueryEventObject) {
            this.comunicacao.enviar(Comunicacao.REQUEST_TESTAR_BOT, {});

        }

        private aoAddConta(e: JQueryEventObject) {
            console.log("aoAddConta");
            if (!this.conectado) {
                this.exibirAlertaMotorNaoConectado();
                return;
            }
            $("#modalAddConta").modal('show')
        }

        private aoClicarInfoDesconectado(e: JQueryEventObject) {
            this.exibirAlertaMotorNaoConectado();
        }

        /**
         Metodos Contas
         */
        private aoClicarAutenticarConta(e: JQueryEventObject) {
            if (!this.conectado) {
                this.exibirAlertaMotorNaoConectado();
                return;
            }
            var conta: IConta = App.Util.getItemArrayById(this.arrayContas, $(e.currentTarget).data('id'));
            var parentItemConta = $(e.currentTarget).parents('.checklist-item');
            console.log("aoClicarAutenticarConta", conta);
            if (!conta) {
                parentItemConta.find('.btn-configurar').click();
                toastr.warning("Antes é Necessários que você informe dados de Autenticação da conta EA", "Informe as credenciais!");
                return;
            }

            Util.exibirModalPaginaCarregando();


            // var request: IRequest = { conta: conta, headless: Util.getModoheadless(parentItemConta.find(`.abrir-navegador-${conta.id}`)), funcao: { id: Util.FUNCAO_AUTENTICAR_CONTA, data: null } };
            // this.comunicacao.enviar(Comunicacao.REQUEST_INICIAR_CONTA, request, (response: IRespostaMensagem) => {
            //     if (response.status) {
            //         toastr.success("Autenticando.", "Sua conta será aberta no navegador e o processo de autenticação começará");
            //     }
            // })
        }
        private aoClicarResolverCaptchaConta(e: JQueryEventObject) {
            if (!this.conectado) {
                this.exibirAlertaMotorNaoConectado();
                return;
            }
            var conta: IConta = App.Util.getItemArrayById(this.arrayContas, $(e.currentTarget).data('id'));
            var parentItemConta = $(e.currentTarget).parents('.checklist-item');
            console.log("aoClicarAutenticarConta", conta);
            if (!conta) {
                parentItemConta.find('.btn-configurar').click();
                toastr.warning("Antes é Necessários que você informe dados de Autenticação da conta EA", "Informe as credenciais!");
                return;
            }

            Util.exibirModalPaginaCarregando();


            // var request: IRequest = { conta: conta, headless: Util.getModoheadless(parentItemConta.find(`.abrir-navegador-${conta.id}`)), funcao: { id: Util.FUNCAO_AUTENTICAR_CONTA, data: null } };
            // this.comunicacao.enviar(Comunicacao.REQUEST_INICIAR_CONTA, request, (response: IRespostaMensagem) => {
            //     if (response.status) {
            //         toastr.success("Autenticando.", "Sua conta será aberta no navegador e o processo de autenticação começará");
            //     }
            // })
        }
        private aoClicarIniciarConta(e: JQueryEventObject) {
            var conta: IConta = App.Util.getItemArrayById(this.arrayContas, $(e.currentTarget).data('id'));
            var parentItemConta = $(e.currentTarget).parents('.checklist-item');
            var request: IRequest = { conta: conta, headless: Util.getModoheadless(parentItemConta.find(`.abrir-navegador-${conta.id}`)), funcao: conta.configuracao.agendamentos[0].tarefa };
            this.comunicacao.enviar(Comunicacao.REQUEST_INICIAR_CONTA, request, (response: IRespostaMensagem) => {
                if (response.status) {
                    toastr.success("Conta Iniciada.", "Iniciou!");
                }
            })
        }
        private aoClicarPararConta(e: JQueryEventObject) {
            var contaResumida = _.pick(App.Util.getItemArrayById(this.arrayContas, $(e.currentTarget).data('id')), 'id', 'email');
            this.comunicacao.enviar(Comunicacao.REQUEST_PARAR_CONTA, contaResumida, (response: IRespostaMensagem) => {
                if (response.status) {
                    this.atualizarViewStatusConta(response.result);
                    toastr.success("Conta Parada.", "Iniciou!");
                }
            })

        }
        private aoClicarPausarConta(e: JQueryEventObject) {
            var contaResumida = _.pick(App.Util.getItemArrayById(this.arrayContas, $(e.currentTarget).data('id')), 'id', 'email');
            this.comunicacao.enviar(Comunicacao.REQUEST_PAUSAR_CONTA, contaResumida, (response: IRespostaMensagem) => {
                if (response.status) {
                    this.atualizarViewStatusConta(response.result);
                    toastr.success("Conta Parada.", "Iniciou!");
                }
            })

        }

        private aoClicarIniciarSbc(e: JQueryEventObject) {
            var conta: IConta = App.Util.getItemArrayById(this.arrayContas, $(e.currentTarget).data('id'));
            // var request: IRequest = {
            //     conta: conta,
            //     funcao: {
            //         id: Util.FUNCAO_SBC,
            //         data: {
            //             id: 1000007,
            //             quality: "gold",
            //             countRare: 1,
            //             CountCommon: 1
            //         }
            //     }
            // };

            // this.comunicacao.enviar(Comunicacao.REQUEST_INICIAR_CONTA, request, (response: IRespostaMensagem) => {
            //     if (response.status) {
            //         toastr.success("Conta Iniciada.", "Iniciou!");
            //     }
            // })
        }
        private aoClicarStatisticaConta(e: JQueryEventObject) {
            console.log("aoClicarStatisticaConta");

        }
        private aoClicarExcluirConta(e: JQueryEventObject) {
            console.log("aoClicarExcluirConta");

        }
        private aoClicarConfigurarConta(e: JQueryEventObject) {
            console.log("aoClicarConfigurarConta");
        }

        private exibirContaAutenticada(elementoLinhaConta: JQuery, conta: IConta) {
            elementoLinhaConta.find('.checklist-item').removeClass('checklist-item-warning').addClass('checklist-item-success');
            elementoLinhaConta.find('.status-autenticada').removeClass('text-warning').addClass('text-success');
            elementoLinhaConta.find('.btn-autenticar-conta').hide();
        }

        private exibirContaNaoAutenticada(elementoLinhaConta: JQuery, conta: IConta) {
            elementoLinhaConta.find('.checklist-item').removeClass('checklist-item-success').addClass('checklist-item-warning');
            elementoLinhaConta.find('.status-autenticada').removeClass('text-success').addClass('text-warning');
            elementoLinhaConta.find('.btn-autenticar-conta').show();
        }
        private exibirViewConexao() {
            if (this.conectado) {
                $(".btn-conectado").show();
                $(".btn-desconectado").hide();
            } else {
                $(".btn-conectado").hide();
                $(".btn-desconectado").show();
            }
        }
        private processarConexaoDisconexao() {
            if (this.conectado) {
                this.ocultarAlertaMotorNaoConectado();
            } else {
                this.exibirAlertaMotorNaoConectado();
                this.alterarEstadoParaBotParado();
            }
        }

        private exibirLog(dadosLog: IDataLog) {
            if (dadosLog.tipo == Util.EVENTO_TIPO_COMPRA && dadosLog.status) {
                Util.efeitoBilhoFundo($('#conta' + dadosLog.idConta.toString()), "#0bff9a91");
            }

            if (dadosLog.tipo == Util.EVENTO_TIPO_ERRO) {
                toastr.warning("Um erro acorreu, se persistir, contate o suporte", "Erro indefinido!");
            }

            this.carregarTabelaLogs(dadosLog);
        }

        private receberEvento(request: IRequestEvento) {
            switch (request.evento) {
                case Util.EVENTO_EXIBIR_LOG:
                    this.exibirLog(request.data);
                    break;

            }

        }
        private receberStatusExecucao(request: IRequestStatusFuncionamento) {
            if (request.status) {
                this.atualizarViewFuncionamentoAtual(request.conta, request.data);
            } else {
                this.reinicializarViewFuncionamentoAtual(request.conta)
            }
        }
        private receberFalhaNaAutenticacao(conta: IConta) {
            Util.ocultarModalPaginaCarregando();
            swal.fire({
                icon: 'error',
                title: 'Falha na Autenticação: ' + conta.email,
                text: 'Email ou senha inválido!'
            })
        }
        private receberAutenticacaoConcluida(conta: IConta) {
            Util.ocultarModalPaginaCarregando();
            console.log("receberAutenticacaoConcluida", conta);
            swal.fire({
                icon: 'success',
                title: 'Autenticação Concluída!',
                text: `Sua conta ${conta.email} foi autenticada e vinculada com sucesso, clique no menu opções da conta, agende tarefas em sua conta ou acesse diretamente o sniper, faça como quiser.`
            }).then((result: any) => {
                Util.exibirModalPaginaCarregando();
                window.location.reload();
            });
        }

        private aoExcluirRegistro(e: JQueryEventObject) {
            var textoExclusao = "Sua conta EA será desvínculada da conta FUTSNIPERWEB e poderá perder todo o histórico de estatísticas e logs";
            Bot.exibirSweetConfirmacaoHtml(e, "Você tem certeza disso?", textoExclusao, "Sim, continuar", this.excluirRegistro);
            return;
        }
        private aoClicarAgendamentoSemFiltro(e: JQueryEventObject) {
            this.exibirAlertaNecessarioCadastrarFiltro();
        }

        private excluirRegistro(e: JQueryEventObject) {
            Util.exibirModalPaginaCarregando();
            this.ajax = new App.Ajax();
            this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url"), { id: $(e.currentTarget).data("id") });
        }

        public static exibirSweetConfirmacaoHtml(e: JQueryEventObject, titulo: string, texto: string, textoBotaoConfirmacao: string = "Sim, continuar!", metodoAexecutarAposConfirmacao: any, corBotaoConfirmacao: string = "#DD6B55"): void {
            swal.fire({
                title: titulo,
                html: texto,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: corBotaoConfirmacao,
                confirmButtonText: textoBotaoConfirmacao,
                cancelButtonText: "cancelar",
                closeOnConfirm: true
            }).then((result: any) => {
                if (result.isConfirmed) {
                    metodoAexecutarAposConfirmacao(e);
                }
            });
        }

        public ocultarAlertaMotorNaoConectado(): void {
            if (this.alertDesconectado) {
                this.alertDesconectado.close();
                this.alertDesconectado = null;
            }
        }
        public exibirAlertaMotorNaoConectado(): void {
            this.alertDesconectado = swal.fire({
                title: 'Não Conectado!',
                confirmButtonColor: "#f9ca3b",
                text: 'Após instalar o FutSniperConnect, clique no ícone para inicia-lo, mantenha-o ligado',
                imageUrl: '/img/gifs/nao-conectado.png',
                imageWidth: 287,
                imageAlt: 'Iniciar FSConnect',
                allowOutsideClick: false,
                allowEscapeKey: false
            })
        }
        public exibirAlertaPrecisaAddConta(): void {
            this.alertPrecisaAddConta = swal.fire({
                title: 'Adicione uma conta!',
                confirmButtonColor: "#f9ca3b",
                text: 'Antes de Iniciar você precisa adicionar uma conta EA, clique no botão "Add Account" para adicionar uma conta EA',
                imageUrl: '/img/gifs/add-conta.png',
                imageWidth: 380,
                imageAlt: 'Add Account',
                allowOutsideClick: false,
                allowEscapeKey: false
            })
        }
        public exibirAlertaNaoExisteAgenda(): void {
            this.alertPrecisaAddConta = swal.fire({
                title: 'Agende Uma Tarefa!',
                confirmButtonColor: "#f9ca3b",
                text: 'Antes de Iniciar você precisa agendar uma tarefa em uma conta EA, clique no botão "Opções" > "Agendar Tarefa"',
                imageUrl: '/img/gifs/agendar.png',
                imageWidth: 248,
                imageHeight: 169,
                imageAlt: 'Agendar tarefa',
                allowOutsideClick: false,
                allowEscapeKey: false
            })
        }
        public exibirAlertaNecessarioCadastrarFiltro(): void {
            this.alertPrecisaAddConta = swal.fire({
                title: 'Crie um filtro!',
                confirmButtonColor: "#f9ca3b",
                text: 'Antes de agendar uma tarefa é necessário que você tenha cadastrado pelo menos 1 filtro, clique na aba "Filtros" para cadastrar um filtro',
                imageUrl: '/img/gifs/add-filtro.png',
                imageWidth: 405,
                imageAlt: 'Cadastre filtro',
                allowOutsideClick: false,
                allowEscapeKey: false
            })
        }
    }
}
